import React from 'react';
import { MailOutlined } from '@ant-design/icons';
import { StyledButton } from './styles';
import DelayedTooltip from 'components/DelayedTooltip';
import { useBundle } from '@amzn/react-arb-tools';
import { safeGetMessage } from '@xbcb/ui-utils';

const EscalatedToMe: React.FC<{ taskCount: number }> = ({ taskCount }) => {
  const [appHeaderBundle] = useBundle('components.AppHeader');
  const title = safeGetMessage(
    appHeaderBundle,
    'assignments_escalated_to_you',
    { taskCount: taskCount },
  );
  return (
    <DelayedTooltip title={title} placement="right">
      <StyledButton disabled={false} shape="circle">
        <MailOutlined data-testid="escalated-to-me-tooltip" />
      </StyledButton>
    </DelayedTooltip>
  );
};

export default EscalatedToMe;
